import { useMsal } from '@azure/msal-react';
import { Box, Divider, Flex, HStack, Text, useToast } from '@chakra-ui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { BsPower } from 'react-icons/bs';
import { FaRegUser } from 'react-icons/fa6';
import { useUser } from '../../contexts/useUser';

export function AvatarMenu() {

  const { user } = useUser();
  const router = useRouter();
  const toast = useToast();
  const { instance } = useMsal();

  async function logOffUser() {
    await router.push('/');
    await instance.logoutRedirect({
      account: instance.getActiveAccount(),
    });
    toast({
      title: 'User logged out',
      variant: 'left-accent',
      status: 'success',
      duration: 5000,
      isClosable: true,
      position: 'bottom-right',
    })
  }

  return (
    <Flex
      borderRadius="6px"
      overflow="hidden"
      flexDirection="column"
      sx={{
        'a': {
          fontSize: '16px !important',
          lineHeight: '24px !important'
        }
      }}
    >
      {user && <>
        <Link href="/user-account" passHref>
          <a>
            <HStack spacing="2" padding="10px" background="gray.100" _hover={{
              color: 'red.400'
            }}>
              <FaRegUser color="red" />
              <Text>
                User Account
              </Text>
            </HStack>
          </a>
        </Link>
        <Divider borderColor="gray.500" />
      </>
      }
      <Box onClick={logOffUser}>
        <HStack spacing="2" padding="10px" background="gray.100" cursor="pointer"
          sx={{
            fontSize: '16px !important',
            lineHeight: '24px !important'
          }}
          _hover={{
            color: 'red.400'
          }}>
          <BsPower color="red" />
          <Text>
            Log out
          </Text>
        </HStack>
      </Box>
    </Flex>
  )
}